import React, { forwardRef, useCallback, useState } from "react";
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import OrcaSecurityMappingForm from './OrcaSecurityMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { useFeatureFlag } from 'contexts/FeatureFlagContext';

function OrcaSecurityCredentialsForm(props, ref) {
    const [token, setToken] = useState();
    const featureFlags = useFeatureFlag();

    const fields = [
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    }, 
    {
        name: "token",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
        props: {
            onChange: (e) => setToken(e.target.value),
        },
    },
    ...(featureFlags.RBVM_ASSETS
        ? 
        [{
            name: "fetchAssets",
            label: "Fetch Assets",
            type: FieldTypes.BOOLEAN,
            disabled: !token,
            inline: true,
        }]
        : 
        []),
    ];

    const parseExtraFields = useCallback((config) => {
        return {
          ...config,
          fetchAssets: config.fetchAssets === "true",
        };
    }, []);

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            parseExtraFields={parseExtraFields}
            MappingForm={OrcaSecurityMappingForm}
            initialValue={{ apiEndpoint: "https://api.<region>.orcasecurity.io" }}
        />
    )
}

export default forwardRef(OrcaSecurityCredentialsForm);